export enum StatusPagamento {
  "Pendente" = 0,
  "Pago" = 1,
  "Pagamento manual" = 2,
  "Processando" = 3,
  "Erro" = 4,
  "Cancelado" = 5,
}
